export default __webpack_public_path__ + "static/media/contractor-logo.e9aea3f4.png";